import { ReactNode } from 'react';

export interface CurrencyProps {
    position: 'left' | 'right' | string | undefined | null;
    symbol: string | undefined | null;
    /** The country code for the currency. */
    code: string;
    amount: number;
}

const CurrencyWrapper = ({ children }: { children: ReactNode }) => (
    <span data-testid="currency" className="currency currencyText">
        {children}
    </span>
);

const CurrencySymbol = ({ symbol }: { symbol: CurrencyProps['symbol'] }) => (
    <span className="currency-symbol" dangerouslySetInnerHTML={{ __html: String(symbol) }} />
);

export const Currency = ({ position, symbol, code, amount }: CurrencyProps) => {
    const amountAsLocaleString = amount.toLocaleString();

    if (!position && !symbol) {
        return (
            <CurrencyWrapper>
                {amountAsLocaleString}
                <span className="currency-code">{` ${code}`}</span>
            </CurrencyWrapper>
        );
    } else {
        return position === 'left' ? (
            <CurrencyWrapper>
                <CurrencySymbol symbol={symbol} />
                {amountAsLocaleString}
            </CurrencyWrapper>
        ) : (
            <CurrencyWrapper>
                {amountAsLocaleString}
                <CurrencySymbol symbol={symbol} />
            </CurrencyWrapper>
        );
    }
};
